import React, { useMemo, useState } from 'react';
import api from '../../api/axios';
import './CrmWritebackHealth.css';

const LABELS = { hubspot: 'HubSpot', salesforce: 'Salesforce', dynamics: 'Dynamics 365' };
function sum(statuses = {}, keys = []) { return keys.reduce((total, key) => total + Number(statuses?.[key] || 0), 0); }

export default function CrmWritebackHealth({ operations, onRefresh }) {
  const [busyProvider, setBusyProvider] = useState('');
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');
  const counts = operations?.crmWriteback?.counts || {};
  const worker = operations?.crmWriteback?.worker || null;
  const rows = useMemo(() => ['hubspot', 'salesforce', 'dynamics'].map((provider) => {
    const statuses = counts[provider] || {};
    return {
      provider,
      statuses,
      waiting: sum(statuses, ['pending', 'processing', 'retry']),
      completed: Number(statuses.completed || 0),
      blocked: sum(statuses, ['blocked', 'dead_letter']),
      deadLetter: Number(statuses.dead_letter || 0),
    };
  }), [counts]);
  const totals = rows.reduce((acc, row) => ({ waiting: acc.waiting + row.waiting, blocked: acc.blocked + row.blocked, completed: acc.completed + row.completed, deadLetter: acc.deadLetter + row.deadLetter }), { waiting: 0, blocked: 0, completed: 0, deadLetter: 0 });

  const retry = async (provider) => {
    setBusyProvider(provider); setError(''); setNotice('');
    try {
      const response = await api.post('/operations/crm-writeback/retry-blocked', { provider });
      setNotice(`${response.data?.retried || 0} ${LABELS[provider]} write-backs opnieuw in de wachtrij gezet.`);
      await onRefresh?.();
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.response?.data?.error || requestError.message);
    } finally { setBusyProvider(''); }
  };

  if (!operations) return <section className="v2-card"><h2>CRM write-back</h2><p className="v2-muted">Operations-status niet beschikbaar.</p></section>;

  return <section className="v2-card crm-writeback-health">
    <div className="v2-card-head"><div><h2>CRM write-back</h2><p>Betrouwbare terugkoppeling van sales-events naar gekoppelde CRM-records.</p></div><span className={`crm-writeback-worker ${worker?.enabled ? 'enabled' : 'disabled'}`}>{worker?.enabled ? 'Worker actief' : 'Worker uit'}</span></div>
    <div className="crm-writeback-summary"><div><strong>{totals.waiting}</strong><span>wacht/retry</span></div><div><strong>{totals.blocked}</strong><span>aandacht</span></div><div><strong>{totals.completed}</strong><span>voltooid</span></div></div>
    <div className="crm-writeback-providers">{rows.map((row) => <div key={row.provider}>
      <div><strong>{LABELS[row.provider]}</strong><span>{row.waiting ? `${row.waiting} in wachtrij` : row.blocked ? 'Actie nodig' : row.completed ? 'Bijgewerkt' : 'Geen write-backs'}</span></div>
      <div className="crm-writeback-provider-counts"><span>{row.completed} klaar</span>{row.statuses.retry ? <span>{row.statuses.retry} retry</span> : null}{row.statuses.blocked ? <b>{row.statuses.blocked} blocked</b> : null}{row.deadLetter ? <b>{row.deadLetter} dead-letter</b> : null}</div>
      {row.blocked > 0 && <button disabled={Boolean(busyProvider)} onClick={() => retry(row.provider)}>{busyProvider === row.provider ? 'Opnieuw plannen…' : 'Exceptions opnieuw proberen'}</button>}
    </div>)}</div>
    {notice && <div className="crm-writeback-notice">{notice}</div>}
    {error && <div className="crm-writeback-error">{error}</div>}
    {totals.blocked > 0 && <p className="crm-writeback-help">Blocked betekent dat configuratie of providerondersteuning ontbreekt. Dead-letter betekent dat tijdelijke fouten te vaak zijn herhaald. Beide blijven bewaard en worden alleen na een bewuste retry opnieuw aangeboden.</p>}
  </section>;
}
